module.exports = __webpack_public_path__ + "static/media/paw-alt.a0ab9901.svg";